<template>
  <div class="lgame-navbar-home-container container-fluid text-center mx-auto px-0"
       :class="{ 'lgame-navbar-scrolled': isScrolled }"
  >
    <nav class="navbar navbar-expand-lg navbar-dark shadow-sm">
      <div
        class="lgame-nav-bar-content container-fluid d-flex justify-content-between align-items-center px-5 py-0"
      >
        <router-link class="navbar-brand" :to="{ name: 'home' }">
          <img
            alt=""
            class="lgame-brand px-2"
            height="36px"
            :src="require('@/assets/imgs/2025/logos/mge-2025-logo.svg')"
          />
        </router-link>
        <button
          class="navbar-toggler collapsed"
          type="button"
          data-toggle="collapse"
          data-target="#lgameNavBar"
          aria-controls="lgameNavBar"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="icon-bar top-bar"></span>
          <span class="icon-bar middle-bar"></span>
          <span class="icon-bar bottom-bar"></span>
        </button>
        <!--<button class="navbar-toggler collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#lgameNavBar"
                        aria-controls="lgameNavBar" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="icon-bar top-bar"></span>
                    <span class="icon-bar middle-bar"></span>
                    <span class="icon-bar bottom-bar"></span>
                </button>-->
        <div
          class="collapse navbar-collapse align-middle px-4 pr-2 px-md-0 py-5 py-md-0 w-100"
          id="lgameNavBar"
          :class="{ 'show-reverse': isAuthenticated }"
        >
          <!-- Left Side Of Navbar -->
          <div class="navbar-nav mr-auto mx-lg-auto mt-2 mt-lg-0 px-2 px-lg-0">
            <router-link
              :to="{ name: 'home' }"
              class="nav-item nav-link"
              exact
              data-toggle="collapse"
              data-target=".navbar-collapse.show"
            >
              {{ $t("navbar.home") }}
            </router-link>
            <router-link
              :to="{ name: 'home', hash: '#tournaments' }"
              class="nav-item nav-link mx-lg-2"
              exact
              data-toggle="collapse"
              data-target=".navbar-collapse.show"
            >
              {{ $t("navbar.tournaments") }}
            </router-link>
            <router-link
              :to="{ hash: '#stream' }"
              class="nav-item nav-link"
              exact
              data-toggle="collapse"
              data-target=".navbar-collapse.show"
            >
              {{ $t("navbar.watch") }}
              <!-- TODO: add stream is live indicator -->
            </router-link>
            <router-link
              :to="{ name: 'home-2024' }"
              class="nav-item nav-link mx-lg-2"
              exact
              data-toggle="collapse"
              data-target=".navbar-collapse.show"
            >
              Edition 2024
            </router-link>
          </div>

          <!-- Right Side Of Navbar -->
          <div
            class="navbar-nav ml-auto px-2 px-md-0"
            :class="{ 'is-auth': isAuthenticated }"
          >
            <!-- Authentication Links -->
            <div
              class="nav-item d-flex justify-content-start justify-content-lg-center align-items-center"
              v-if="!isAuthenticated"
            >
              <a
                class="nav-link"
                type="button"
                @click="triggerLogin(false)"
                data-toggle="modal"
                data-target="#loginModal"
              >
                {{ $t("navbar.register") }}
              </a>
            </div>
            <div
              class="nav-item log-in-button-container-wrapper d-flex justify-content-start justify-content-lg-center align-items-center ml-lg-2"
              data-toggle="modal"
              data-target="#loginModal"
              v-if="!isAuthenticated"
            >
              <div
                class="log-in-button-container d-flex justify-content-center align-items-center"
                @click="triggerLogin(true)"
              >
                <a
                  class="nav-link log-in-button py-0 m-0 text-white"
                  type="button"
                  data-toggle="modal"
                  data-target="#loginModal"
                >
                  {{ $t("navbar.log_in") }}
                </a>
              </div>
            </div>

            <div
              class="nav-item d-flex justify-content-end w-100 mt-2 mt-lg-0"
              v-if="isAuthenticated"
            >
              <NavBarUserCard></NavBarUserCard>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <LgameLogin
      :login="isLogin"
      :action-after="login_afterAction"
      @hide-login="closeLogin"
      v-if="initLogin"
    >
    </LgameLogin>
  </div>
</template>
<script>
import NavBarUserCard from "@/components/common/NavBarUserCard.vue";
import axios from "axios";
import LgameLogin from "@/components/2025/Nav/LgameLogin.vue";
export default {
  name: "NavBar",
  components: {
    LgameLogin,
    NavBarUserCard,
  },
  data() {
    return {
      isLoading: true,
      isLogin: true,
      initLogin: false,
      login_afterAction: null,
      isScrolled: false,
    };
  },
  computed: {
    isAuthenticated: {
      get() {
        return this.$store.state.currentUser.isAuthenticated;
      },
    },
    loggedUser: {
      get() {
        return this.$store.state.currentUser.user.name;
      },
    },
    isOrganizer: {
      get() {
        return !!this.$store.state.currentUser.user?.organizer;
      },
    },
  },
  methods: {
    checkAuth() {
      if (localStorage.getItem("lgame_userData")) {
        const currentUserData = JSON.parse(
          localStorage.getItem("lgame_userData")
        );
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + currentUserData.accessToken;
        this.$store.dispatch(
          "currentUser/setCurrentUser",
          currentUserData.userId,
          currentUserData.accessToken
        );
      }
    },
    triggerLogin(isLogin) {
      this.isLogin = isLogin;
      this.initLogin = true;
      console.log("login ..... clicked");
    },
    closeLogin() {
      this.initLogin = false;
    },
    goOrganize() {
      if (this.isOrganizer) {
        window.location = process.env.MIX_ORGANIZER_URL + "organiser";
      } else {
        this.$router.push({ name: "organiser" });
      }
    },
    collapseNavbar() {
      const navbar = document.getElementById("lgameNavBar");
      const isCollapsed = navbar.classList.contains("show");
      if (isCollapsed) {
        navbar.classList.remove("show");
      }
    },
    handleScroll(){
      this.isScrolled =  window.scrollY > 1;
    }
  },
  beforeCreate() {
    //console.log('before create: ');
    //console.log(this.$store.state.currentUser.isAuthenticated);
  },
  created() {
    //console.log('created');
    this.checkAuth();
    //console.log('isAuthenticated: '+ this.isAuthenticated);

    this.$root.$on("trigger-register", () => {
      this.triggerLogin(false);
    });
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  mounted() {
    this.$root.$on("show-login", (actionData) => {
      this.initLogin = true;
      this.triggerLogin(true);
      this.login_afterAction = actionData;
    });

    window.addEventListener("scroll", this.handleScroll);
  },
};
</script>
<style scoped>
.lgame-navbar-home-container {
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ml-user-select: none;
  position: fixed;
  z-index: 1080;
  top: 10px;
  left: 10px;
  background-color: var(--navbar-bg-color);
  border-radius: 8px 8px 0 0;
  width: calc(100% - 20px);
  transition:
      top 200ms ease-in-out,
      left 200ms ease-in-out,
      width 200ms ease-in-out,
      border-radius 200ms ease-in-out,
      background-color 200ms ease-in-out;
}
.lgame-navbar-scrolled {
  position: fixed;
  width: 100% !important;
  top: 0 !important;
  left: 0 !important;
  border-radius: 0;
  border-bottom: 1px solid #171717;
  background-color: var(--navbar-bg-color-onscroll);
}

.log-in-button-container-wrapper {
  cursor: pointer;
}

.log-in-button-container {
  /* color: white !important;
    background-color: #ff0000;
    height: 28px;
    width: fit-content;
    clip-path: polygon(6px 0, 100% 0, 100% calc(100% - 6px), calc(100% - 6px) 100%, 0 100%, 0 6px);
    */
}

.lgame-nav-bar-content {
  position: relative;
}

.navbar {
  /* border-bottom: 2px solid rgba(1, 13, 17, 0.93); */
  backdrop-filter: blur(10px);
  border-radius: 8px 8px 0 0;
}

.nav-link.router-link-exact-active,
.nav-link.router-link-active {
  color: var(--main-color) !important;
  font-weight: 600;
}

/* style navbar collapse overriding*/
.navbar-dark .navbar-toggler {
  border: none !important;
  outline: none !important;
}

.navbar-dark:active,
.navbar-toggler:active {
  outline: none !important;
  border: none !important;
}
.navbar-dark:focus,
.navbar-toggler:focus {
  outline: none !important;
  border: none !important;
  box-shadow: unset !important;
}

.navbar-toggler.collapsed ~ .navbar-collapse {
  transition: right 500ms ease-in-out;
}

.collapsing {
  height: calc(calc(var(--vh, 1vh) * 100) - 60px) !important;
  -webkit-clip-path: polygon(
    100% 0,
    100% 100%,
    20px 100%,
    20px calc(100% - 140px),
    0 calc(100% - 160px),
    0 80px,
    20px 60px,
    20px 0
  );
  clip-path: polygon(
    100% 0,
    100% 100%,
    20px 100%,
    20px calc(100% - 140px),
    0 calc(100% - 160px),
    0 80px,
    20px 60px,
    20px 0
  );
  position: absolute;
  top: 56px;
  right: -100vw;
  overflow: hidden !important;
  width: 90vw !important;
  background-color: var(--navbar-bg-color-onscroll);
  backdrop-filter: blur(10px);
  display: flex;
  flex-direction: column;
  justify-content: space-between !important;
  background-size: 100% auto;
  background-position: top right;
}

.navbar-collapse.show:before {
  content: " ";
  width: 20px;
  height: 100px;
  position: absolute;
  top: 0;
  left: 15px;
  background-color: red;
  z-index: -1;
}

.navbar-collapse.show:after {
  content: " ";
  position: absolute;
  top: 0;
  right: 0;
  height: calc(calc(var(--vh, 1vh) * 100) - 60px) !important;
  overflow: hidden !important;
  overflow: unset !important;
  width: 90vw !important;
  background: var(--navbar-bg-color-onscroll);
  backdrop-filter: blur(10px);
  clip-path: polygon(
    100% 0,
    100% 100%,
    20px 100%,
    20px calc(100% - 140px),
    0 calc(100% - 160px),
    0 80px,
    20px 60px,
    20px 0
  );
  z-index: -1;
  background-size: 100% auto;
  background-position: top right;
}

.navbar-collapse.show {
  position: absolute;
  top: 56px;
  right: -1rem;
  height: calc(calc(var(--vh, 1vh) * 100) - 60px) !important;
  overflow: hidden !important;
  overflow: unset !important;
  width: 90vw !important;
  /*background-color: #00171F;
  -webkit-clip-path: polygon(100% 0, 100% 100%, 20px 100%, 20px calc(100% - 140px), 0 calc(100% - 160px), 0 80px, 20px 60px, 20px 0);
  clip-path: polygon(100% 0, 100% 100%, 20px 100%, 20px calc(100% - 140px), 0 calc(100% - 160px), 0 80px, 20px 60px, 20px 0);*/
  transition: right 300ms ease-in-out;
  /**/
  display: flex;
  flex-direction: column;
  justify-content: space-between!important;
}
.navbar-collapse.show.show-reverse{
  display: flex;
  flex-direction: column-reverse;
  justify-content: flex-end !important;
  align-items: center;
  padding-right: 0 !important;
  padding-top: 0 !important;
}
.collapsing.show-reverse{
  display: flex;
  flex-direction: column-reverse;
  justify-content: flex-end !important;
  align-items: center;
  padding-top: 0 !important;
}
.navbar-collapse.show.show-reverse>.navbar-nav.is-auth:last-child{
  display:flex;
  flex-direction: column-reverse!important;
}
.navbar-collapse.show > .navbar-nav:not(.is-auth):last-child{
  display:flex;
  flex-direction: column-reverse!important;
  width: 100%;
}

.closer-div{
  visibility: hidden;
}
.navbar-toggler:not(.collapsed)~.closer-div{
  visibility: visible !important;
  content: ' ';
  background: red;
  width: 20px;
  height: 160px;
  position: absolute;
  top: 56px;
  left: 20px;
  transition: visibility 500ms ease-in-out;
}

.nav-link {
  display: block;
  font-size: 12pt;
  padding: 0.5rem 1rem;
  font-family: "sqwaredregular", sans-serif;

  color: white !important;
}

/* style navbar overriding */
@media only screen and (max-width: 600px) {
  .lgame-nav-bar-content {
    padding: unset !important;
  }

  .lgame-brand {
    height: 32px;
  }

  .lgame-nav-bar-content {
    position: relative;
    filter: drop-shadow(-4px 0px 4px rgba(0, 0, 0, 0.7));
  }
  .log-in-button-container {
    padding-inline: 0 !important;
  }
  .nav-link {
    padding-inline: 0 !important;
    text-align: left;
  }
}

@media only screen and (max-width: 680px) {
}

@media only screen and (min-width: 600px) and (max-width: 768px) {
  .lgame-navbar-home-container{
    top:0 !important;
    left:0 !important;
    width:100% !important;
    border-radius:0 !important;
  }
  .lgame-nav-bar-content {
    padding: unset !important;
  }

  .lgame-brand {
    width: 160px;
    height: 34px;
  }

  .lgame-nav-bar-content {
    filter: drop-shadow(-4px 0px 4px rgba(0, 0, 0, 0.7));
  }
  .nav-link {
    padding-inline: 0 !important;
    text-align: left;
  }
  .log-in-button-container {
    padding-inline: 0 !important;
  }
}

/*navbar toggler custom */
.navbar-toggler .icon-bar {
  display: block;
  width: 22px;
  height: 2px;
  margin: 4px 0 4px 0;
  transition: all 0.2s;
}

.navbar-dark .navbar-toggler .icon-bar {
  background: #e9e9e9;
}

.navbar-toggler .icon-bar:nth-of-type(1) {
  transform: rotate(45deg);
  transform-origin: 10% 10%;
}

.navbar-toggler .icon-bar:nth-of-type(2) {
  opacity: 0;
  filter: alpha(opacity=0);
}

.navbar-toggler .icon-bar:nth-of-type(3) {
  transform: rotate(-45deg);
  transform-origin: 10% 90%;
}

.navbar-toggler.collapsed .icon-bar:nth-of-type(1) {
  transform: rotate(0);
}

.navbar-toggler.collapsed .icon-bar:nth-of-type(2) {
  opacity: 1;
  filter: alpha(opacity=100);
}

.navbar-toggler.collapsed .icon-bar:nth-of-type(3) {
  transform: rotate(0);
}
</style>
